import React from 'react';

const C = { bg:'#040000', gold:'#f5c842', gold2:'#d4a843', cream:'#f0e6cc', cream2:'#c8b89a', muted:'#8a7060', border:'rgba(212,168,67,0.15)' };

// Ordered premium-first so the price ladder reads cleanly top-to-bottom.
const AD_TYPES = [
  {
    icon: '▶️',
    name: 'Pre-roll',
    where: 'Plays before a video starts — our most premium, highest-visibility spot, seen by every viewer',
    size: 'Image or short video clip',
    price: '₹15,000 / month',
  },
  {
    icon: '🖼️',
    name: 'Banner Ad',
    where: 'Shown on the homepage, between video sections (e.g. between "NP Originals" and "Devotional")',
    size: 'Wide image, roughly 1200 x 120 pixels',
    price: '₹10,000 / month',
  },
  {
    icon: '🎬',
    name: 'L-Band (Video Overlay)',
    where: 'Appears as an overlay during video playback',
    size: 'Wide image, roughly 1200 x 60 pixels',
    price: '₹5,000 / month',
  },
];

export default function AdvertisePage({ onBack }) {
  const waMsg = encodeURIComponent("Hi, I'm interested in advertising on Nethaji Prime OTT. Could you share more details?");

  const sectionTitle = { color: C.gold, fontFamily: "'Cinzel',serif", fontSize: 20, marginBottom: 14, marginTop: 36 };
  const card = { background: 'rgba(255,255,255,0.03)', border: '1px solid ' + C.border, borderRadius: 12, padding: 20, marginBottom: 14 };

  return (
    <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background: C.bg, zIndex: 9999, overflowY: 'auto', WebkitOverflowScrolling: 'touch', padding: '40px 20px' }}>
      <div style={{ maxWidth: 680, margin: '0 auto', paddingBottom: 40 }}>
        {onBack && <button onClick={onBack} style={{ background: 'none', border: 'none', color: C.cream2, cursor: 'pointer', marginBottom: 20, fontSize: 13 }}>&larr; Back</button>}

        <h1 style={{ color: C.gold, fontFamily: "'Cinzel',serif", fontSize: 28, marginBottom: 8 }}>Advertise with Nethaji Prime OTT</h1>
        <p style={{ color: C.cream2, fontSize: 14, lineHeight: 1.7 }}>
          Nethaji Prime OTT is a growing Tamil sociopolitical media and entertainment platform, reaching a dedicated Tamil-speaking
          audience across news, devotional content, astrology, entertainment, and more. Advertising with us puts your brand
          directly in front of an engaged community.
        </p>

        <div style={sectionTitle}>📦 Ad Types &amp; Pricing</div>
        {AD_TYPES.map(ad => (
          <div key={ad.name} style={card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8, flexWrap: 'wrap', gap: 8 }}>
              <div style={{ color: '#fff', fontSize: 16, fontWeight: 700 }}>{ad.icon} &nbsp;{ad.name}</div>
              <div style={{ color: C.gold, fontSize: 16, fontWeight: 900 }}>{ad.price}</div>
            </div>
            <p style={{ color: C.cream2, fontSize: 13, margin: '4px 0' }}>{ad.where}</p>
            <p style={{ color: C.muted, fontSize: 12, margin: 0 }}>Recommended size: {ad.size}</p>
          </div>
        ))}

        <div style={sectionTitle}>📋 How It Works</div>
        <div style={card}>
          <ol style={{ color: C.cream2, fontSize: 13, lineHeight: 2, paddingLeft: 20, margin: 0 }}>
            <li>Choose the ad type and duration that fits your budget</li>
            <li>Contact us using the details below to share your ad design and discuss payment</li>
            <li>Our team reviews your ad and sets it live, usually within 24 hours</li>
            <li>Your ad runs for the agreed duration, reaching our Tamil audience</li>
          </ol>
        </div>

        <div style={sectionTitle}>📞 Contact Us to Get Started</div>
        <div style={card}>
          <a href={`https://wa.me/919342330234?text=${waMsg}`} target="_blank" rel="noreferrer"
            style={{ display: 'flex', alignItems: 'center', gap: 10, color: '#25D366', fontSize: 15, fontWeight: 700, textDecoration: 'none', marginBottom: 14 }}>
            📱 WhatsApp: +91 93423 30234
          </a>
          <a href="mailto:contact@nethajiprime.com?subject=Advertising%20Inquiry"
            style={{ display: 'flex', alignItems: 'center', gap: 10, color: C.gold, fontSize: 15, fontWeight: 700, textDecoration: 'none' }}>
            ✉️ Email: contact@nethajiprime.com
          </a>
        </div>

        <p style={{ color: C.muted, fontSize: 11, textAlign: 'center', marginTop: 30 }}>
          All ads are reviewed by our team before going live to ensure they meet our content guidelines.
        </p>
      </div>
    </div>
  );
}
